import React from "react";
import { getSortDirectionIcon, toggleSort } from "../../utils/FilterHelpers";

const CardTableWithActions = ({
    headers,
    keys,
    rows,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
}) => {
    const renderHeadersData = () => {
        return (
            headers &&
            headers.map((header, index) => {
                if (!header.roles) {
                    return (
                        <th
                            key={index}
                            scope="col"
                            className="px-6 py-3 text-center text-xs text-gray-500 uppercase tracking-wider"
                        >
                            <div className="flex items-center justify-center min-w-18 sm:min-w-22 ">
                                {!header.skipSort && (
                                    <i
                                        onClick={() =>
                                            toggleSort(
                                                header.name,
                                                sortBy,
                                                setSortBy,
                                                sortDirection,
                                                setSortDirection
                                            )
                                        }
                                        className={`fas ${getSortDirectionIcon(
                                            header.name,
                                            sortBy,
                                            sortDirection
                                        )} table-head-icon`}
                                    />
                                )}
                                <span className="ml-2">{header.label}</span>
                            </div>
                        </th>
                    );
                }
            })
        );
    };

    const getKeyValue = (row, key, index) => {
        if (key.element) return key.element(row, index);
        let rowValue = key.subKey ? row[key.name][key.subKey] : row[key.name];
        rowValue = key.parseMethod ? key.parseMethod(rowValue) : rowValue;
        return rowValue;
    };

    const renderRowsData = () => {
        return (
            rows &&
            rows.map((row, index) => {
                return (
                    <tr className="tr-ele" key={index}>
                        {keys &&
                            keys.map((currentKey, keyIndex) => {
                                const processedKeyValue = getKeyValue(
                                    row,
                                    currentKey,
                                    index
                                );
                                return (
                                    <td
                                        className="px-6 py-3 whitespace-wrap"
                                        key={keyIndex}
                                    >
                                        {processedKeyValue}
                                    </td>
                                );
                            })}
                    </tr>
                );
            })
        );
    };
    return (
        <>
            <div className="flex flex-col mb-5">
                <div className="table-responsive actions-responsive-table action-wrapper shadow overflow-hidden border-b border-gray-200 sm:rounded-lg small-scroll-x small-scroll-y">
                    <table className="table-striped min-w-full divide-y divide-gray-200 text-xs text-center">
                        <thead className="parent-head">
                            <tr>{renderHeadersData()}</tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {renderRowsData()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default CardTableWithActions;
